import SelfInitComponent from "General/global-js/SelfInitComponent";
import "./metanavlogin.scss";
import {DropdownHelper} from "General/global-js/DropdownHelper";

class MetaNavigationLogin extends SelfInitComponent {
  constructor(selector) {

    super(selector);
  }

  init() {
    var $dropdown = $("#metanavloginLayer-collapse");
    var $dropdowntoggle = $(".metanavloginLayer-link__collapse");
    var outsideClickTargets = "metanavloginLayer-link, metanavloginLayer-link__icon,metanavloginLayer-close-link__icon, metanavloginLayer-link__text," +
      "metanavloginLayer-link__collapse, metanavloginLayer-collapse, metanavloginLayer__label";

    DropdownHelper.init($dropdown, $dropdowntoggle, outsideClickTargets);
  }
}

new MetaNavigationLogin("#headerMetaNavigationLoginLayer");
